// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.create-template .golden-rod {
  border-radius: 5px;
  background-color: #FEBF31;
  color: black;
  font-weight: 500;
  margin-bottom: 16px;
  padding: 4px 8px;
  width: fit-content;
}

.create-btn-wrapper {
  margin-left: -10px;
  margin-top: 40px;
}

.page-title {
  color: #0669B3;
  font-weight: 700;
  margin-bottom: 24px;
}

.template-wrapper {
  background-color: #EDF0F1;
  border-radius: 10px;
  margin-bottom: 32px;
  min-height: 300px;
  padding: 24px;
  width: 100%;
}
.template-wrapper .school-manage-helper-text {
  margin: 24px 0px;
}

.template-title-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.table-header {
  display: flex;
}
.table-header #text {
  color: #0A4064;
  font-weight: 600;
}
.table-header .header-item-container {
  border: 1px solid #A7A9AC;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 12%;
  padding: 4px 8px;
  background: #c0def0;
  font-size: 1rem;
}
.table-header .first {
  width: 16%;
}

.status-container {
  display: flex;
}
.status-container .item-container {
  border-top: 1px solid #D1D3D4;
  border-bottom: 1px solid #D1D3D4;
  border-left: 1px solid #D1D3D4;
  border-right: 1px solid #D1D3D4;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 12%;
  padding: 4px 8px;
  font-weight: 400;
}
.status-container .first-col {
  font-weight: 600;
  font-size: 1rem;
  color: #0669B3;
  word-wrap: anywhere;
  justify-content: flex-start;
  width: 16%;
}
.status-container .numbers {
  font-weight: 400;
}

.disabled-input {
  background: #D1D3D4;
  color: black;
}

.secondary-text {
  font-size: 14px;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolTemplate.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANI;ECDA,kBDE0B;EACtB,yBDiBI;EChBJ,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AASR;;AALA;EACI,kBAAA;EACA,gBAAA;AAQJ;;AANA;EACI,cDaS;ECZT,gBAAA;EACA,mBAAA;AASJ;;AANA;EACI,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AASJ;AAPI;EACI,gBAAA;AASR;;AALA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAQJ;;AAHA;EACI,aAAA;AAMJ;AALI;EACI,cDxCE;ECyCF,gBAAA;AAOR;AAJI;EACI,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,mBDhDI;ECiDJ,eAAA;AAMR;AAJI;EACI,UAAA;AAMR;;AAHA;EACI,aAAA;AAMJ;AAJI;EACI,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAMR;AAJI;EACI,gBAAA;EACA,eAAA;EACA,cDpDK;ECqDL,mBAAA;EACA,2BAAA;EACA,UAAA;AAMR;AAJI;EACI,gBAAA;AAMR;;AAFA;EACI,mBDrEI;ECsEJ,YAAA;AAKJ;;AAFA;EACI,eAAA;EACA,mBAAA;AAKJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.create-template {\n    .golden-rod {\n        @include borderRadius(5px);\n        background-color: $important;\n        color: black;\n        font-weight: 500;\n        margin-bottom: 16px;\n        padding: 4px 8px;\n        width: fit-content;\n    }\n}\n\n.create-btn-wrapper {\n    margin-left: -10px;\n    margin-top: 40px;\n}\n.page-title {\n    color: $pearl-blue;\n    font-weight: 700;\n    margin-bottom: 24px;;\n}\n\n.template-wrapper {\n    background-color: $grey0;\n    border-radius: 10px;\n    margin-bottom: 32px;\n    min-height: 300px;\n    padding: 24px;\n    width: 100%;\n\n    .school-manage-helper-text {\n        margin: 24px 0px;\n    }\n}\n\n.template-title-section {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n}\n\n\n\n.table-header {\n    display: flex;\n    #text {\n        color: $dk-blue;\n        font-weight: 600;\n    }\n\n    .header-item-container {\n        border: 1px solid $grey2;\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n        width: 12%;\n        padding: 4px 8px;\n        background: $pale-blue;\n        font-size: 1rem;\n    }\n    .first {\n        width: 16%;\n    }\n}\n.status-container {\n    display: flex;\n\n    .item-container {\n        border-top: 1px solid $grey1;\n        border-bottom: 1px solid $grey1;\n        border-left: 1px solid $grey1;\n        border-right: 1px solid $grey1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 60px;\n        width: 12%;\n        padding: 4px 8px;\n        font-weight: 400;\n    }\n    .first-col {\n        font-weight: 600;\n        font-size: 1rem;\n        color: $pearl-blue;\n        word-wrap: anywhere;\n        justify-content: flex-start;\n        width: 16%;\n    }\n    .numbers {\n        font-weight: 400;\n    }\n}\n\n.disabled-input {\n    background: $grey1;\n    color: black;\n}\n\n.secondary-text {\n    font-size: 14px;\n    font-weight: normal;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
